import React from 'react';
import { Check, X } from 'lucide-react';
interface ChecklistProps {
  items: string[];
  type?: 'success' | 'warning';
  className?: string;
}
export function Checklist({
  items,
  type = 'success',
  className = ''
}: ChecklistProps) {
  return <ul className={`list-none pl-0 my-6 space-y-4 ${className}`} data-id="element-1">
      {items.map((item, index) => <li key={index} className="flex items-start text-[19px] text-[#2c3e50] leading-relaxed" data-id="element-2">
          <span className="mr-3 mt-1 flex-shrink-0" data-id="element-3">
            {type === 'success' ? <span className="text-xl" data-id="element-4">✅</span> : <span className="text-xl" data-id="element-5">❌</span>}
          </span>
          <span data-id="element-6">{item}</span>
        </li>)}
    </ul>;
}